import { ApiClientErrorResponse } from '~/ApiClient';

export default class ImpersonateLoginErrorResponse extends ApiClientErrorResponse {
	handleUserNotFound() {
		return this.handle('authentication-user-not-found');
	}

	handleUserNotRegistered() {
		return this.handle('authentication-impersonate-user-not-registered');
	}

	handleNotAllowed() {
		return this.handle('authentication-impersonate-not-allowed');
	}

	handleExternalServiceNotAllowed() {
		return this.handle('authentication-impersonate-external-service-not-allowed');
	}

	handleAccessDenied() {
		return this.handle(null);
	}
}
